import { MessageContentBlock } from "@hex/common";

import { AgentChatMessageFragment } from "../hex-project-shared/messages/AgentChatMessage.generated";

import { AgentChatMessage, AgentChatThread } from "./agentChatMessage.types";
import {
  AgentChatThreadFragment,
  AgentChatThreadListItemFragment,
} from "./sharedThreadManagementUtils.generated";

export const messageFragmentToAgentChatMessage = (
  m: AgentChatMessageFragment,
): AgentChatMessage => {
  return {
    id: m.id,
    role: m.role,
    staticId: m.staticId,
    revision: m.revision,
    content: m.content as MessageContentBlock[],
    createdDate: m.createdDate,
    agentChatThreadId: m.agentChatThreadId,
    runId: m.runId,
    debugInfo: m.debugInfo,
  };
};

export const threadFragmentToAgentChatThread = (
  t: AgentChatThreadFragment | AgentChatThreadListItemFragment,
): AgentChatThread => {
  return {
    id: t.id,
    title: t.title,
    createdDate: t.createdDate,
    status: t.status,
    autoSaveHexVersionId: t.autoSaveHexVersionId,
    agentMessages: [],
    editsToReview: [],
  };
};
